module.exports = __webpack_public_path__ + "static/media/laundry-2.0cee633c.jpg";